// frontend/src/shared/ui/Card.js

import React from "react";
import colors from "../theme/colors";
import radius from "../theme/radius";
import shadows from "../theme/shadows";

export default function Card({
  children,
  style = {},
  className = "",
  padding = 14,
  align = "center",
  as: Component = "div",
  ...rest
}) {
  return (
    <Component
      className={className}
      style={{
        background: colors.surface,
        borderRadius: radius.lg,
        border: `1px solid ${colors.border}`,
        boxShadow: shadows.card,
        padding,
        display: "flex",
        alignItems: align === "start" ? "flex-start" : "center",
        ...style,
      }}
      {...rest}
    >
      {children}
    </Component>
  );
}